import React, { createContext, useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import { get } from 'lodash';
import { FEATURE_URL } from '../config';
import { metricsApi } from '../api/metricsApi';

const FeaturesContext = createContext();

class ErrorWithHTTPStatusCode extends Error {
    constructor(message, status) {
        super(message);
        this.status = status;
    }
}

const fetchFeaturesJson = async () => {
    try {
        const { data, headers } = await axios.get(FEATURE_URL);

        if (!new RegExp('^application/json').test(headers['content-type'])) {
            // When feature file isn't returned the response could be a status code 200
            throw new ErrorWithHTTPStatusCode('Invalid features fetched', 404);
        }

        return data;
    } catch (err) {
        const statusCode = get(err, 'response.status', 500);
        await metricsApi.errorMetric(
            'fetchFeaturesJson',
            err instanceof ErrorWithHTTPStatusCode ? err.status : statusCode,
            err.message
        );
        return null;
    }
};

const defaultFeatures = {
    countdown_timer_enabled: true,
    entry_animation_enabled: true,
    betting_links_enabled: true,
    share_enabled: true
};

export const FeaturesProvider = ({ children }) => {
    const [features, setFeatures] = useState(defaultFeatures);

    useEffect(() => {
        const fetchingSetFeatures = async () => {
            const data = await fetchFeaturesJson();
            if (data) {
                setFeatures(data);
            }
        };
        fetchingSetFeatures();
    }, []);

    return (
        <FeaturesContext.Provider value={{ features, setFeatures }}>
            {children}
        </FeaturesContext.Provider>
    );
};

FeaturesProvider.propTypes = {
    children: PropTypes.node.isRequired
};

export const useFeatures = () => useContext(FeaturesContext);
